<template>
    <div class="day-component">
        <b-input 
            placeholder="Select day" 
            type="date" 
            :required="required"
            v-bind:value="value"
            v-on:input="$emit('input', $event)">
        </b-input>
    </div>
</template>

<script>
var moment = require('moment');
var dateFormat = 'MM/DD/YYYY'

export default {
    name: 'Day',
    components: {
    },
    props: {
        component: Object,
        value: String,
        required: Boolean,
    },
    data: function () {
        return {
        }
    },
    methods: {

    },
    mounted(){

    },     
    computed: {

    }
}

</script>

<style>

</style>

